var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1049,
    height: 716,
    viewBox: "0 0 1049 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.56 0C48.0375 0 4.25407 39.5869 4 88.0731C4 88.0731 4 88.1498 4 88.2266C4 88.3033 4 88.3033 4 88.38V618.66C4 667.223 47.9528 707.04 101.56 707.04H947.08C1000.69 707.04 1044.64 667.223 1044.64 618.66V88.38C1044.64 88.3033 1044.64 88.3033 1044.64 88.2266C1044.64 88.1498 1044.64 88.0731 1044.64 88.0731C1044.39 39.5869 1000.6 0 947.08 0H101.56ZM157.962 39.28H890.763L524.32 270.664L157.962 39.28ZM85.8081 41.5816L524.32 318.536L962.917 41.5816C985.105 47.6423 1001.11 65.9014 1001.28 88.1498C1001.2 92.2927 996.538 100.578 989.763 107.253C982.903 114.004 976.213 118.224 976.213 118.224L976.128 118.377L524.32 408.067L72.5122 118.377L72.4275 118.224C72.4275 118.224 65.7372 114.004 58.8775 107.253C52.1025 100.578 47.4447 92.2927 47.36 88.1498C47.5294 65.9014 63.5353 47.6423 85.8081 41.5816ZM47.36 150.292L47.5294 150.445L47.6988 150.522V150.599L112.4 192.027V667.76H101.56C71.4113 667.76 47.36 645.972 47.36 618.66V150.292ZM1001.28 150.292V618.66C1001.28 645.972 977.229 667.76 947.08 667.76H936.24V192.027L1000.94 150.599V150.522L1001.28 150.292ZM155.76 219.799L524.32 456.093L892.88 219.799V667.76H155.76V219.799Z",
    fill: "#020001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_4",
    x: 0,
    y: 0,
    width: 1048.64,
    height: 715.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_4",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLight);
export default __webpack_public_path__ + "static/media/mail_light.e4ba67caa67079d92920de77df562ef6.svg";
export { ForwardRef as ReactComponent };